export default __webpack_public_path__ + "static/media/1_0156.6a3659f9.webp";